import config from 'config';
import axios from 'helpers/axios';

const fetchBannerRequest = () => axios({
  method: 'get',
  url: `${config.apiUrl}/announcement`
});

export default fetchBannerRequest;
